import { configureStore, StateFromReducersMapObject } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import { apiService } from '@/store/apiService';
import { apiServiceListener } from '@/store/apiServiceListeners';
import { deleteCompany } from '@/store/deleteCompany';
import { markForDeletion } from '@/store/markForDeletion';
import { auth } from '@/store/auth';

export type InitialState = StateFromReducersMapObject<typeof mainReducer>;

const mainReducer = {
    [apiService.reducerPath]: apiService.reducer,
    [deleteCompany.name]: deleteCompany.reducer,
    [markForDeletion.name]: markForDeletion.reducer,
    [auth.name]: auth.reducer,
};

export const createStore = (initialState?: InitialState) => {
    let store = configureStore({
        reducer: {
            [apiService.reducerPath]: apiService.reducer,
            [deleteCompany.name]: deleteCompany.reducer,
            [markForDeletion.name]: markForDeletion.reducer,
            [auth.name]: auth.reducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().prepend(apiService.middleware, apiServiceListener.middleware),
    });
    if (initialState) {
        store = configureStore({
            preloadedState: initialState,
            reducer: mainReducer,
            middleware: (getDefaultMiddleware) =>
                getDefaultMiddleware().prepend(apiService.middleware),
        });
    }

    return store;
};

export type Store = ReturnType<typeof createStore>;
export type ApplicationDispatch = Store['dispatch'];
export type ApplicationState = ReturnType<Store['getState']>;

export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
export const useAppDispatch: () => ApplicationDispatch = useDispatch;
